<template>
  <div v-show="viewEdit">
    <v-card>
      <v-tabs v-model="tab" class="elevation-2" left show-arrows>
        <v-tabs-slider></v-tabs-slider>

        <v-tab :href="`#tab-0`">
          <v-icon class="mx-1">mdi-account-circle</v-icon>
          עדכון פרטים אישיים
        </v-tab>
        <v-tab :href="`#tab-1`">
          <v-icon class="mx-1">mdi-email-outline</v-icon>
          עדכון כתובת אימייל
        </v-tab>
        <v-tab :href="`#tab-2`">
          <v-icon class="mx-1">mdi-lock</v-icon>
          עדכון סיסמה
        </v-tab>

        <v-tab-item :value="'tab-0'">
          <v-card flat tile>
            <v-card-text>
              <CVUserDetailsEdit
                :display-save="true"
                :show-birth-year="true"
                :activateOtpOnPage="true"

              />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-1'">
          <v-card flat tile>
            <v-card-text>
              <EmailUpdate :display-save="true" />
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'tab-2'">
          <v-card flat tile>
            <v-card-text>
              <PasswordUpdate :display-save="true" />
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </div>
</template>

<script>
import CVUserDetailsEdit from '@/components/Dialogs/CV_Popup/CVUserDetailsEdit';
import PasswordUpdate from '@/components/Dialogs/CV_Popup/PasswordUpdate';
import EmailUpdate from '@/components/Dialogs/CV_Popup/EmailUpdate';

export default {
  components: { CVUserDetailsEdit, EmailUpdate, PasswordUpdate },

  props: {},

  data() {
    return {
      viewEdit: false,
      tab: null,
      tabItems: [
        { text: 'עדכון פרטים אישיים', icon: 'mdi-account-circle' },
        { text: ' עדכון כתובת אימייל', icon: 'mdi-email-outline' },
        { text: ' עדכון סיסמה', icon: 'lock' }
      ],
      TAB_QUERY_PARAM_KEY: 'tab',
      changeEmailTab :'tab-1'
    };
  },

  mounted() {
    this.$nuxt.$on('toggleEditForm', this.toggleEdit);
    this.$nuxt.$on('hideEditForm', this.hideEditForm);
  },

  methods: {
    toggleEdit(currentTab) {
      const urlParams = new URLSearchParams(window.location.search);
      const tab = urlParams.get(this.TAB_QUERY_PARAM_KEY);

      if (tab && tab === this.changeEmailTab) {
        this.tab = tab;
      } else {
        this.tab = currentTab;
      }
      this.viewEdit = !this.viewEdit;
    },
    hideEditForm() {
      this.viewEdit = false;
    }
  },

  beforeDestroy() {
    this.$nuxt.$off('toggleEditForm');
    this.$nuxt.$off('hideEditForm');
  }
};
</script>
